import React from 'react';
import ciscoLogo from '../../../../../assets/images/cisco-meraki-logo-light-digital.svg';

const LogoBanner = () => {
  return (
    <div style={{
        height: 56,
        backgroundImage: "linear-gradient(to right, #143052, #07182D)"
      }}>
      <div style={{
        height: 2,
        backgroundImage: "linear-gradient(to right, blue, cyan, cyan, magenta, orange)"
      }}/>
      <div style={{paddingLeft: 10, paddingTop: 6}}>
        <img src={ciscoLogo} style={{height: 40 }}/>
      </div>
    </div>
  );
};

export default LogoBanner;
